// imports
import Modal from 'bootstrap/js/dist/modal';
import React, { useRef, forwardRef, useImperativeHandle } from 'react';
import { ICON } from '../../assets';
import { Status } from '../../common/types';

// interfaces / types / consts
interface Props {
  title?: string;
  message: string;
  btnText?: string;
  status: Status | 'info';
  onClick?: () => void;
}

// react component
const Popup = forwardRef((props: Props, ref) => {
  const {
    status, title, message, btnText, onClick
  } = props;
  // hooks configuration
  const modalRef = useRef<HTMLDivElement>(null);

  // private methods
  const getModal = (create = false): Modal | null => {
    const modalElement = modalRef.current;
    if (modalElement) {
      let bsModal = Modal.getInstance(modalElement);
      if (!bsModal && create) { bsModal = new Modal(modalElement, { keyboard: false, backdrop: 'static' }); }
      return bsModal;
    }
    return null;
  };
  const show = (): void => {
    const bsModal = getModal(true);
    bsModal?.show();
  };
  const hide = (): void => {
    const bsModal = getModal();
    bsModal?.hide();
  };
  useImperativeHandle(ref, () => ({ show, hide }));

  // render
  return (
    <div className="modal fade popup" ref={modalRef} tabIndex={-1} aria-labelledby="LoadingModal" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-body">
            {(status === 'info' || status === 'success')
              && (
                <button
                  type="button"
                  onClick={hide}
                  aria-label="close"
                  className="btn-close"
                  disabled={status !== 'info' && status !== 'success'}
                />
              )}
            <div className="body-content">
              {status === 'error' && <img className="status-icon" src={ICON.CROSS} alt="cross" />}
              {status === 'success' && <img className="status-icon" src={ICON.CHECKMARK} alt="checkmark" />}
              <div className="title">
                {status === 'error' && 'Uh-oh'}
                {status === 'success' && 'Success!'}
                {['idle', 'loading', 'info'].includes(status) && title}
              </div>
              <p className="msg">{message}</p>
              <button
                type="button"
                className="popup-btn"
                disabled={status !== 'idle' && status !== 'info'}
                hidden={Boolean(!btnText) || status === 'success' || status === 'error'}
                onClick={onClick}
              >
                {btnText}
                {status === 'loading' && <span className="spinner" role="status" />}
              </button>
              <div className="spinner-container" hidden={Boolean(btnText) || status !== 'loading'}>
                <div className="spinner" role="status" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

// display name
Popup.displayName = 'Popup';

// exports
export default Popup;

// default props
Popup.defaultProps = { btnText: '', title: 'Standby', onClick: () => null };
